/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
let t=null;async function e(){return t||(t=await import("./createUtils.js")),t}export{e as loadCreateUtils};
